// Content-driven "coming soon" placeholder pages — each is a thin wrapper
// over the shared ComingSoon component. When we build real content for any
// of these, replace the wrapper with the real page. Privacy / Terms /
// Contact live in dedicated files under /pages/legal/ and /pages/.
import ComingSoon from "./ComingSoon";

export function HowItWorks() {
  return (
    <ComingSoon
      title="How Last Bookmark works"
      description="A step-by-step tour of posting a project, finding your reader, funding escrow, exchanging feedback, and closing the loop with a review. In the meantime, the homepage sections below cover the essentials."
      sections={[
        { title: "For Authors", body: "Post a project, review applicants, fund escrow, get thoughtful feedback, and build a long-term reader team you trust." },
        { title: "For Beta Readers", body: "Browse projects in your genres, apply with a personal note, chat with authors, and earn a Quality Score that grows with every completed read." },
        { title: "Escrow & payouts", body: "Funds sit safely with the platform while the reader works. Released on completion — no chasing, no disputes." },
        { title: "Reviews & Reputation", body: "Structured five-category reviews build a portfolio you can point to for years." },
      ]}
      eta="Detailed guide in Phase 2"
    />
  );
}

export function Handbook() {
  return (
    <ComingSoon
      title="The Last Bookmark Handbook"
      description="Our field guide for authors and beta readers — how to write a great project brief, how to give feedback that actually helps, what makes a five-star Quality Score, and everything else we've learned running the platform."
      waitlist={{
        source: "handbook",
        headline: "Get the Handbook the day it drops.",
        subhead: "One short email when the guide is ready — no other newsletters.",
      }}
      sections={[
        { id: "highlights", title: "Handbook Highlights", body: "Curated must-reads: our top 10 tips for authors, the beta reader's toolkit, and the escrow safety guide." },
        { title: "Author playbooks", body: "Sample project briefs, questionnaires that get better feedback, and how to pick your first reader with confidence." },
        { title: "Beta reader playbooks", body: "How to structure your first read-through, how to phrase hard feedback kindly, and how to grow from Bronze to Gold certification." },
        { title: "Community norms", body: "The unwritten rules — how we keep Last Bookmark warm, professional, and genuinely useful for everyone." },
      ]}
      eta="Launching alongside Phase 2"
    />
  );
}

export function Blog() {
  return (
    <ComingSoon
      title="The Last Bookmark Blog"
      description="Craft essays, reader interviews, marketplace insights, and behind-the-scenes notes from the team building Last Bookmark. First posts are being drafted — join the platform to get them in your inbox."
      waitlist={{
        source: "blog",
        headline: "Get the first post in your inbox.",
        subhead: "One email per post. Craft, reader interviews, and marketplace insights — never spam.",
      }}
      sections={[
        { title: "Writers' Room", body: "Interviews with published authors on their beta-reading rituals." },
        { title: "The Reader's Desk", body: "How top beta readers structure their notes, and what makes feedback feel like a gift." },
        { title: "Craft & Community", body: "Trends, essays, and hot takes from around the writing world." },
      ]}
      eta="First posts coming soon"
    />
  );
}
